import React from 'react';

export const SuperAdminPage = () => {
  return (
    <div>
      <h1 className="text-2xl font-medium mb-6">Super Administrator</h1>
      {/* Rest of your existing logs page content */}
    </div>
  );
}; 